import { AgGridModule } from "ag-grid-angular";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SearchRoutingModule } from "./search-routing.module";
import { SearchComponent } from "./search.component";
import { TranslateModule } from "@ngx-translate/core";
import { GenericModule } from "../../shared/generic/generic.module";
import { DynamicFormBuilderModule } from "../../shared/generic/form/dynamic-form-builder/dynamic-form-builder.module";
import { NbCardModule } from "@nebular/theme";

@NgModule({
  declarations: [SearchComponent],
  imports: [
    CommonModule,
    SearchRoutingModule,
    TranslateModule,
    AgGridModule.withComponents([SearchComponent]),
    NbCardModule
  ],
  exports: [SearchComponent],
})
export class SearchModule {}
